import React from "react";
// import dgLogo from '../../../res/images/standard.png';
import dgLogo from '../../../res/domd2026/DG logga v2 RGB.png';

const DgLogo = () => <img src={dgLogo} height={'40px'} alt="DG Logo"/>;

export default DgLogo;
